/* ============================================================
   LAINOHA — PRODUITS CLIQUABLES PANIER BYOB
   Version basée sur les données natives BYOB

   PRINCIPE VALIDÉ :
   - lecture dans window.__cuByobVm.buildrules
   - produits dans rule.json_products
   - aucune ouverture forcée d'accordéon par CSS
   - aucune modification des variables du Tracker
   - si nécessaire, clic sur le vrai .circle-step
   - BYOB + Tracker réagissent normalement
============================================================ */

(function () {
  'use strict';

  const DEBUG = true;
  const MAX_WAIT_MS = 3200;
  const RETRY_MS = 120;

  function log() {
    if (!DEBUG) return;

    console.log.apply(
      console,
      ['🔗 LAINOHA produit:'].concat(Array.from(arguments))
    );
  }

  /* ============================================================
     CURSEUR CLIQUABLE
  ============================================================ */

  const style = document.createElement('style');

  style.textContent = `
    .byob-cart-drawer .drawer-product-image,
    .byob-cart-drawer .drawer-product-title,
    #cartDrawer .drawer-product-image,
    #cartDrawer .drawer-product-title {
      cursor: pointer !important;
    }
  `;

  document.head.appendChild(style);

  /* ============================================================
     OUTILS
  ============================================================ */

  function normalizeText(text) {
    return String(text || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[’']/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getByobVm() {
    return window.__cuByobVm || null;
  }

  function getBuildrules() {
    const vm = getByobVm();

    if (!vm || !Array.isArray(vm.buildrules)) {
      return [];
    }

    return vm.buildrules;
  }

  /* ============================================================
     TROUVER LE PRODUIT + SA COLLECTION + SON ÉTAPE
     DIRECTEMENT DANS BUILDRULES
  ============================================================ */

  function findProductContextByTitle(productTitle) {
    const wanted = normalizeText(productTitle);
    const rules = getBuildrules();

    if (!wanted || !rules.length) {
      return null;
    }

    const candidates = [];

    rules.forEach(function (rule, ruleIndex) {
      const products = Array.isArray(rule.json_products)
        ? rule.json_products
        : [];

      products.forEach(function (product) {
        if (!product || !product.title) {
          return;
        }

        const current = normalizeText(product.title);

        if (!current) {
          return;
        }

        let score = 0;

        if (current === wanted) {
          score = 1000;
        } else if (
          wanted.startsWith(current) ||
          current.startsWith(wanted)
        ) {
          score = 800;
        } else if (
          wanted.includes(current) ||
          current.includes(wanted)
        ) {
          score = 600;
        } else {
          const wantedWords = wanted
            .split(' ')
            .filter(Boolean);

          const currentWords = current
            .split(' ')
            .filter(Boolean);

          const common = wantedWords.filter(function (word) {
            return currentWords.includes(word);
          }).length;

          if (common >= 3) {
            score = common * 20;
          }
        }

        if (!score) {
          return;
        }

        candidates.push({
          score: score,
          step: ruleIndex + 1,
          ruleIndex: ruleIndex,
          rule: rule,
          collectionTitle: rule.title || '',
          product: product
        });
      });
    });

    if (!candidates.length) {
      return null;
    }

    candidates.sort(function (a, b) {
      return b.score - a.score;
    });

    return candidates[0];
  }

  /* ============================================================
     TOUS LES SKU DU PRODUIT
  ============================================================ */

  function getProductSkus(product) {
    if (
      !product ||
      !Array.isArray(product.variants)
    ) {
      return [];
    }

    const skus = [];

    product.variants.forEach(function (variant) {
      const sku = String(
        (variant && variant.sku) || ''
      ).trim();

      if (
        sku &&
        !skus.includes(sku)
      ) {
        skus.push(sku);
      }
    });

    return skus;
  }

  /* ============================================================
     EXCLURE NOS FAUSSES CARTES
  ============================================================ */

  function isFakeByobCard(card) {
    if (!card) {
      return true;
    }

    return (
      card.classList.contains(
        'cu-byob-section-card'
      ) ||
      card.classList.contains(
        'cu-byob-section-coded-card'
      ) ||
      card.classList.contains(
        'cu-byob-collection-banner-card'
      )
    );
  }

  /* ============================================================
     RETROUVER LA CARTE PRODUIT PAR SKU
  ============================================================ */

  function findProductCardBySkus(
    skus,
    expectedStep
  ) {
    if (
      !Array.isArray(skus) ||
      !skus.length
    ) {
      return null;
    }

    const skuSet = new Set(
      skus.map(function (sku) {
        return String(sku)
          .trim()
          .toLowerCase();
      })
    );

    const skuElements = Array.from(
      document.querySelectorAll(
        '.byob-product-sku .byob-inline-block'
      )
    );

    let fallback = null;

    for (
      let i = 0;
      i < skuElements.length;
      i++
    ) {
      const skuElement = skuElements[i];

      const currentSku = String(
        skuElement.textContent || ''
      )
        .trim()
        .toLowerCase();

      if (!skuSet.has(currentSku)) {
        continue;
      }

      const card = skuElement.closest(
        '.grid-product'
      );

      if (
        !card ||
        isFakeByobCard(card)
      ) {
        continue;
      }

      const container = card.closest(
        '.byob-accordion-container'
      );

      const cardStep = container
        ? Number(
            container.dataset.step || 0
          )
        : 0;

      if (
        expectedStep &&
        cardStep &&
        cardStep !== expectedStep
      ) {
        continue;
      }

      if (!fallback) {
        fallback = card;
      }

      const computed =
        window.getComputedStyle(card);

      const visible =
        computed.display !== 'none' &&
        computed.visibility !== 'hidden' &&
        card.getClientRects().length > 0;

      if (visible) {
        return card;
      }
    }

    return fallback;
  }

  /* ============================================================
     ÉTAPE ACTIVE
  ============================================================ */

  function getCurrentStep() {
    const buttons = Array.from(
      document.querySelectorAll(
        '.circle-step'
      )
    );

    const currentIndex =
      buttons.findIndex(
        function (button) {
          return (
            button.classList.contains(
              'active'
            ) ||
            button.classList.contains(
              'cu-v2-current'
            )
          );
        }
      );

    return currentIndex >= 0
      ? currentIndex + 1
      : null;
  }

  /* ============================================================
     ALLER À UNE ÉTAPE VIA LE VRAI CERCLE

     TEST F12 VALIDÉ :
     .circle-step[step - 1].click()
  ============================================================ */

  function goToStep(step) {
    const buttons = Array.from(
      document.querySelectorAll(
        '.circle-step'
      )
    );

    const button =
      buttons[step - 1];

    if (!button) {
      console.warn(
        '⚠️ Cercle BYOB introuvable pour étape',
        step
      );

      return false;
    }

    const currentStep =
      getCurrentStep();

    if (currentStep === step) {
      log(
        'Déjà dans étape',
        step
      );

      return true;
    }

    log(
      'Navigation native vers étape',
      step,
      '-',
      button.innerText.trim()
    );

    button.click();

    return true;
  }

  /* ============================================================
     FERMER LE PETIT PANIER
  ============================================================ */

  function closeSmallCart() {
    const drawer =
      document.getElementById(
        'cartDrawer'
      );

    if (drawer) {
      drawer.classList.remove(
        'open'
      );
    }

    const tracker =
      document.querySelector(
        '.byob-progress-container'
      );

    if (tracker) {
      tracker.classList.remove(
        'drawer-open'
      );
    }
  }

  /* ============================================================
     ATTENDRE LE RENDU DE LA CARTE APRÈS CHANGEMENT D'ÉTAPE
  ============================================================ */

  function waitForProductCard(
    skus,
    expectedStep,
    callback
  ) {
    const startedAt =
      Date.now();

    function check() {
      const card =
        findProductCardBySkus(
          skus,
          expectedStep
        );

      if (card) {
        callback(card);
        return;
      }

      if (
        Date.now() - startedAt >=
        MAX_WAIT_MS
      ) {
        console.warn(
          '⚠️ Carte produit introuvable après changement d’étape.',
          {
            step: expectedStep,
            skus: skus
          }
        );

        return;
      }

      setTimeout(
        check,
        RETRY_MS
      );
    }

    check();
  }

  /* ============================================================
     SCROLL PRODUIT
  ============================================================ */

  function scrollToProductCard(card) {
    if (!card) {
      return;
    }

    card.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
      inline: 'nearest'
    });
  }

  /* ============================================================
     CLIC PRODUIT DU PETIT PANIER
  ============================================================ */

  function goToProductFromDrawer(
    drawerItem
  ) {
    if (!drawerItem) {
      return;
    }

    const titleElement =
      drawerItem.querySelector(
        '.drawer-product-title'
      );

    const productTitle =
      titleElement
        ? titleElement.textContent.trim()
        : '';

    if (!productTitle) {
      console.warn(
        '⚠️ Titre produit du petit panier introuvable.'
      );

      return;
    }

    /*
      Ici on ne regarde PAS la collection visible.

      On cherche directement dans :
      buildrules[].json_products
    */

    const context =
      findProductContextByTitle(
        productTitle
      );

    if (!context) {
      console.warn(
        '⚠️ Produit introuvable dans buildrules.json_products :',
        productTitle
      );

      return;
    }

    const skus =
      getProductSkus(
        context.product
      );

    if (!skus.length) {
      console.warn(
        '⚠️ Aucun SKU trouvé pour :',
        context.product.title
      );

      return;
    }

    log(
      'Produit trouvé',
      {
        drawerTitle: productTitle,
        product:
          context.product.title,
        collection:
          context.collectionTitle,
        step:
          context.step,
        skus:
          skus
      }
    );

    /*
      On ferme le petit panier.
    */

    closeSmallCart();

    /*
      Si le produit est dans une autre collection,
      on clique sur LE VRAI CERCLE.

      Le Tracker gère donc lui-même son état
      et son message comme lors d'un clic normal.
    */

    const navigationOk =
      goToStep(
        context.step
      );

    if (!navigationOk) {
      return;
    }

    /*
      Ensuite on attend que BYOB rende la carte.
    */

    waitForProductCard(
      skus,
      context.step,
      function (card) {

        /*
          Très petit délai supplémentaire
          pour laisser la collection terminer
          son affichage.
        */

        setTimeout(
          function () {

            const refreshedCard =
              findProductCardBySkus(
                skus,
                context.step
              ) || card;

            scrollToProductCard(
              refreshedCard
            );

            log(
              'Navigation terminée vers',
              context.product.title
            );

          },
          120
        );
      }
    );
  }

  /* ============================================================
     ÉCOUTER IMAGE + TITRE DU PETIT PANIER
  ============================================================ */

  document.addEventListener(
    'click',
    function (event) {

      const clicked =
        event.target.closest(
          '.byob-cart-drawer .drawer-product-image,' +
          '.byob-cart-drawer .drawer-product-title,' +
          '#cartDrawer .drawer-product-image,' +
          '#cartDrawer .drawer-product-title'
        );

      if (!clicked) {
        return;
      }

      const drawerItem =
        clicked.closest(
          '.drawer-product-item'
        );

      if (!drawerItem) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      goToProductFromDrawer(
        drawerItem
      );
    },
    true
  );




/* ============================================================
   LAINOHA — NOM DE COLLECTION TOUJOURS JUSTE
   Petit panier BYOB uniquement

   SOURCE DE VÉRITÉ :
   window.__cuByobVm.buildrules[].json_products

   IMPORTANT :
   - aucun message Tracker modifié
   - aucune étape modifiée
   - aucun clic déclenché
   - aucune mémoire Tracker modifiée
   - affichage du petit panier seulement
============================================================ */

function cleanDrawerCollectionTitle(
  collectionTitle,
  step
) {
  let name = String(
    collectionTitle || ''
  ).trim();


  /*
    Étape 2 :
    L'ÉTAPE 2-UNE PAUSE RÉCONFORTANTE
    devient :
    UNE PAUSE RÉCONFORTANTE
  */

  if (step === 2) {
    name = name.replace(
      /^L['’]ÉTAPE\s*2\s*[-–—:]\s*/i,
      ''
    );

    name = name.replace(
      /^ÉTAPE\s*2\s*[-–—:]\s*/i,
      ''
    );
  }


  /*
    Étape 3 :
    L'ÉTAPE 3-CRÉER UN COCON DE DOUCEUR
    devient :
    CRÉER UN COCON DE DOUCEUR
  */

  if (step === 3) {
    name = name.replace(
      /^L['’]ÉTAPE\s*3\s*[-–—:]\s*/i,
      ''
    );

    name = name.replace(
      /^ÉTAPE\s*3\s*[-–—:]\s*/i,
      ''
    );
  }


  return name.trim();
}


/* ============================================================
   CORRIGER LES NOMS DANS LE PETIT PANIER
============================================================ */

function refreshDrawerCollectionNames() {

  const items =
    document.querySelectorAll(
      '#cartDrawer .drawer-product-item,' +
      '.byob-cart-drawer .drawer-product-item'
    );


  if (!items.length) {
    return;
  }


  items.forEach(
    function (item) {

      const titleElement =
        item.querySelector(
          '.drawer-product-title'
        );

      const collectionElement =
        item.querySelector(
          '.drawer-product-collection'
        );


      if (
        !titleElement ||
        !collectionElement
      ) {
        return;
      }


      const productTitle =
        titleElement.textContent.trim();


      if (!productTitle) {
        return;
      }


      /*
        On utilise exactement la même fonction
        déjà utilisée par les produits cliquables.
      */

      const context =
        findProductContextByTitle(
          productTitle
        );


      if (!context) {
        return;
      }


      /*
        Le coffret conserve son libellé actuel.

        La carte conserve également son libellé
        actuel puisqu'il est déjà correct.

        Nous corrigeons les vraies collections
        de produits : étapes 2 et 3.
      */

      if (
        context.step !== 2 &&
        context.step !== 3
      ) {
        return;
      }


      const correctName =
        cleanDrawerCollectionTitle(
          context.collectionTitle,
          context.step
        );


      if (!correctName) {
        return;
      }


      /*
        Écrire seulement si nécessaire.
      */

      if (
        collectionElement
          .textContent
          .trim() !== correctName
      ) {

        collectionElement.textContent =
          correctName;

      }

    }
  );
}


/* ============================================================
   LE PANIER EST RECONSTRUIT PAR LE TRACKER.

   Donc dès qu'il est reconstruit,
   nous remettons les noms exacts.
============================================================ */

let drawerCollectionRefreshTimer =
  null;


function scheduleDrawerCollectionRefresh() {

  clearTimeout(
    drawerCollectionRefreshTimer
  );


  drawerCollectionRefreshTimer =
    setTimeout(
      function () {

        refreshDrawerCollectionNames();

      },
      40
    );
}


/* ============================================================
   OBSERVER LE PETIT PANIER SEULEMENT
============================================================ */

function startDrawerCollectionObserver() {

  const drawer =
    document.getElementById(
      'cartDrawer'
    ) ||
    document.querySelector(
      '.byob-cart-drawer'
    );


  if (!drawer) {

    setTimeout(
      startDrawerCollectionObserver,
      300
    );

    return;
  }


  /*
    Première correction immédiate.
  */

  refreshDrawerCollectionNames();


  const observer =
    new MutationObserver(
      function () {

        scheduleDrawerCollectionRefresh();

      }
    );


  observer.observe(
    drawer,
    {
      childList: true,
      subtree: true
    }
  );


  console.log(
    '✅ Lainoha — noms de collections panier surveillés'
  );
}


startDrawerCollectionObserver();




  console.log(
    '✅ Lainoha — byob-product-links.js actif (buildrules + navigation native)'
  );

})();